<template>
  <div>
    <ejs-grid
      :dataSource="storedata"
      ref="storegrid"
      height="calc(100vh - 276px)"
      :allowResizing="true"
      allowPaging="true"
    >
      <e-columns>
        <e-column
          field="neName"
          :headerText="$t('Software.td_neID')"
          width="6%"
          clipMode="EllipsisWithTooltip"
        ></e-column>
        <e-column
          field="neType"
          :headerText="$t('Software.td_neName')"
          width="6%"
          clipMode="EllipsisWithTooltip"
          :valueAccessor="deviceTypeFormatter"
        ></e-column>
        <e-column
          field="pkgVer"
          :headerText="$t('Software.td_packageVer')"
          width="12%"
          clipMode="EllipsisWithTooltip"
          :valueAccessor="typeFormat"
        ></e-column>
        <!-- <e-column
          field="mainPkgVer"
          :headerText="$t('Software.td_mainPkgVer')"
          width="8%"
          clipMode="EllipsisWithTooltip"
          :valueAccessor="typeFormat"
        ></e-column> -->
        <e-column
          field="isSupportMS"
          :headerText="$t('Software.td_isSupportMS')"
          width="7%"
          :valueAccessor="binaryFormatter"
          clipMode="EllipsisWithTooltip"
        ></e-column>
        <e-column
          field="isSupportRbk"
          :headerText="$t('Software.td_isSupportRbk')"
          width="6%"
          :valueAccessor="binaryFormatter"
          clipMode="EllipsisWithTooltip"
        ></e-column>
        <e-column
          field="pkgStatus"
          :headerText="$t('Software.td_pkgStatus')"
          width="6%"
          :valueAccessor="pkgStatusFormatter"
          clipMode="EllipsisWithTooltip"
        ></e-column>
        <e-column
          field="detail"
          :headerText="$t('Software.query_remarks')"
          width="8%"
          clipMode="EllipsisWithTooltip"
        ></e-column>
      </e-columns>
    </ejs-grid>
  </div>
</template>

<script>
export default {
  name: "QueryStoreVersion",
  data() {
    return {
      storedata: [],
      deviceTypeMap: new Map() // 设备码和类型对应关系
        .set(10001, this.$t("Topo.devEPC"))
        .set(10002, this.$t("Topo.devhytalkPro"))
        .set(10003, this.$t("Topo.devMCS"))
        .set(10004, this.$t("Topo.deveNodeB"))
        .set(10005, this.$t("Topo.deveNodeBIOPS"))
        .set(10006, this.$t("Topo.deviBS"))
        .set(10007, this.$t("Topo.deviBSB"))
        .set(10008, this.$t("Topo.devODBBU"))
        .set(10009, this.$t("Topo.devgNB"))
        .set(10010, this.$t("Topo.devhytalk")),
      binarymap: new Map([
        [1, this.$t("Software.vmyes")],
        [0, this.$t("Software.vmno")],
      ]),
      pkgstamap: new Map([
        [0, this.$t("Software.reserved")],
        [1, this.$t("Software.running")],
        [2, this.$t("Software.active")],
      ]),
    };
  },
  methods: {
    queryStoreVersionOne(param) {
      //运行版本查询
      console.log("param==", param);
      this.axios
        .post("/lte/ems/verquery_new/queryStoreVerByNeId", [param.id])
        .then((response) => {
          if (response.data.errorCode == "SUCCESS") {
            console.log("response.data.resultVal", response.data.resultVal);
            this.storedata = response.data.resultVal;
          }
        });
    },
    typeFormat(field, data, column) {
      if (data[field] === null || data[field] === "") {
        return "---";
      }
      return data[field];
    },
    pkgStatusFormatter(field, data, column) {
      if (data[field] === null || data[field] === "") {
        return "---";
      }
      return this.pkgstamap.get(data[field]);
    },
    binaryFormatter(field, data, column) {
      if (data[field] === null || data[field] === "") {
        return "---";
      }
      return this.binarymap.get(data[field]);
    },
    // 格式化设备类型
    deviceTypeFormatter(field, devData) {
      return this.deviceTypeMap.get(devData["typeCode"]);
    },
  },
};
</script>

